import React from "react";
import "./index.scss";
import BannerFiForPage from "../../components/_shared/ui-blocks/BannerFiForPage";
import { Button, Input, message, Result } from "antd";
import { FaArrowRightLong } from "react-icons/fa6";
import { FaArrowLeftLong } from "react-icons/fa6";
import { dataDefaultFetch, postDataAPI } from "../../utils/fetchData";
import { white_space_String } from "../../utils/validations";
import * as dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOne } from "../../redux/actions/contentsAction";
import HelmetContents from "../../components/Head";
import LoadingContents from "../../components/_shared/LoadingContents";

const { Search } = Input;

export default function Blog() {
  const [searchv, setSearchV] = React.useState(null);
  const refS = React.useRef(null);
  const [filters, setFilters] = React.useState({
    page: 0,
    limit_page: 3,
    filters: { is_delete: false },
  });
  const [blogs, setBlogs] = React.useState(dataDefaultFetch);
  const [blogsFets, setBlogsFet] = React.useState(dataDefaultFetch);

  const navigate = useNavigate();

  const contents = useSelector((state) => state.contents);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getOne("blog", message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    (async () => {
      setBlogs({ ...blogs, loading: true });
      try {
        const res = await postDataAPI("blog/all", filters);

        setBlogs({
          ...blogs,
          data: res.data.data,
          loading: false,
          total: res.data.total,
        });
        setTimeout(() => {
          window.scroll({
            top: 0,
            behavior: "smooth",
          });
        }, 1000);
      } catch (error) {
        setBlogs({ ...blogs, data: null, loading: false, error: error });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  React.useEffect(() => {
    (async () => {
      setBlogsFet({ ...blogsFets, loading: true });
      try {
        const res = await postDataAPI("blog/all", {
          page: 0,
          limit_page: 3,
          filters: { is_delete: false },
        });

        setBlogsFet({
          ...blogs,
          data: res.data.data,
          loading: false,
          total: res.data.total,
        });
      } catch (error) {
        setBlogsFet({ ...blogsFets, data: null, loading: false, error: error });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSearch = (e) => {
    const reset = { ...filters };
    if (!e) {
      delete reset.filters["$text"];
    } else {
      reset.filters["$text"] = { $search: white_space_String(e) };
    }
    reset.page = 0;
    setFilters(reset);
    refS.current.blur();
  };

  const totalPage = (totalData) => {
    let page = 0;
    if (totalData) {
      page =
        Number(totalData / filters.limit_page) % 1 !== 0
          ? Math.floor(totalData / filters.limit_page)
          : totalData / filters.limit_page - 1;
    } else {
      page = 0;
    }
    return page;
  };

  const handlePageNum = (key, total) => {
    const reset = { ...filters };

    switch (key) {
      case "next":
        reset.page = reset.page + 1;
        break;
      case "pre":
        reset.page = reset.page - 1;
        break;

      default:
        break;
    }

    if (reset.page < 0) {
      reset.page = 0;
    } else if (reset.page > totalPage(total)) {
      reset.page = totalPage(total);
    }
    setFilters(reset);
  };

  if (blogs.error) {
    return (
      <Result
        status="500"
        title="500"
        subTitle="Sorry, something went wrong."
        extra={
          <Button
            type="primary"
            onClick={() => navigate("/", { replace: true })}
          >
            Back Home
          </Button>
        }
      />
    );
  }

  return (
    <div className="blog-container">
      <HelmetContents
        title={contents.data?.title}
        description={contents.data?.desc}
        imageUrl={contents.data?.url_img}
        canonicalUrl={"/blog"}
        imageAlt={"sunflower-tours-hg-blog-image"}
      />
      <BannerFiForPage title={"News"} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Articles",
          headline: contents.data?.title,
          description: contents.data?.desc,
          image: contents.data?.url_img,
          author: {
            "@type": "Person",
            name: "Sunflower Ha Giang",
            email: "info.hgmotorbiketours@gmail.com",
          },
          datePublished: "2025-03-01",
          dateModified: "2025-03-02",
        })}
      </script>
      <div className="container">
        <div className="row mr-80">
          <div className="col-8">
            {!blogs.loading && blogs.data ? (
              blogs.data.length > 0 ? (
                blogs.data.map((i, k) => (
                  <div className="wrap-box-sinblog" key={k}>
                    <img
                      src={i.img.url}
                      alt={`annh blog ${k}`}
                      onClick={() => {
                        navigate(`/blog/${i.slug}`);
                      }}
                    />

                    <div className="d-flex">
                      <div className="tag">
                        <p>{i.categories}</p>
                      </div>
                      <div className="tag-time">
                        <p>{dayjs(i.createdAt).format("DD/MM/YYYY")}</p>
                      </div>
                    </div>
                    <h2
                      onClick={() => {
                        navigate(`/blog/${i.slug}`);
                      }}
                    >
                      {i.title}
                    </h2>

                    <div className="desc-wr">{i.short_content}</div>

                    <p
                      className="rm"
                      onClick={() => {
                        navigate(`/blog/${i.slug}`);
                      }}
                    >
                      Read more
                    </p>
                  </div>
                ))
              ) : (
                <p>None of any blog here!</p>
              )
            ) : (
              <LoadingContents />
            )}

            <div className="pagination">
              <ul className="d-flex">
                <li
                  onClick={() =>
                    filters.page === 0
                      ? false
                      : handlePageNum("pre", blogs?.total)
                  }
                >
                  <FaArrowLeftLong />
                </li>
                <li>
                  <span>{filters.page + 1}</span>
                </li>
                <li
                  onClick={() =>
                    filters.page === totalPage(blogs?.total)
                      ? false
                      : handlePageNum("next", blogs?.total)
                  }
                >
                  <FaArrowRightLong />
                </li>
              </ul>
            </div>
          </div>
          <div className="col-4">
            <Search
              placeholder="Search blogs here...."
              onSearch={onSearch}
              ref={refS}
              enterButton
              value={searchv}
              onChange={(e) => {
                setSearchV(e.target.value);
              }}
            />
            <div className="left-content-t">
              <h6>Recent Posts</h6>
              <ul>
                {!blogsFets.loading && blogsFets.data ? (
                  blogsFets.data?.length > 0 ? (
                    blogsFets.data.map((i, k) => (
                      <li key={k} className="d-flex">
                        <div className="i-lc-left">
                          <img src={i.img.url} alt={`annh blog ${k}`} />
                        </div>
                        <div className="i-lc-right">
                          <p
                            onClick={() => {
                              navigate(`/blog/${i.slug}`);
                            }}
                          >
                            {i.title}
                          </p>
                          <p>{dayjs(i.createdAt).format("DD/MM/YYYY")}</p>
                          <p
                            onClick={() => {
                              navigate(`/blog/${i.slug}`);
                            }}
                          >
                            Read more {">>"}
                          </p>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li>None of any blog here!</li>
                  )
                ) : (
                  <LoadingContents />
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
